export default "__VITE_ASSET__BnHZClgg__"